import { get as lodashGet } from "lodash-es";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

// Instance level config ENABLE_USER_IMPERSONATION
export const useEnableUserImpersonation = (): boolean => {
  const { data: config } = useInstanceConfigQuery();
  return (
    lodashGet(config, "feature_toggles.ENABLE_USER_IMPERSONATION", false) &&
    !sessionStorage.getItem("impersonateeId")
  );
};
